/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationCustomColumnKind =
  (typeof GroupByConversationCustomColumnKind)[keyof typeof GroupByConversationCustomColumnKind];

export const GroupByConversationCustomColumnKind = {
  conversation_custom_column: 'conversation_custom_column',
} as const;
